/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-04-22 15:26:14
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\logManageMent\eventMonitoring\eventMonitoring.js
 * @Description: 
 */
/**
 *  logManageMentModule
 *
 * Description  管理配置 日志管理 事件监控
 * rebuild:SMG 2016-4-20
 */
'use strict';
angular.module('logManageMentEventMonitoringModule', [	
    'eventMonitoringAllQueuesModule',
    'eventMonitoringMyQueuesModule',
    'eventQueuesModalServiceModule'
])
    .controller('logManageMentEventMonitoringCtrl', securityLog);
securityLog.$injector = ['$scope'];

function securityLog($scope) {

}
